import { SkeletonLoader } from '@kanda-libs/ks-design-library';

import AppleLogo from '../../assets/apple.png';

interface ViewComponentProps {
  /**
   * Disabled state for social buttons
   */
  socialDisabled?: boolean;
  /**
   * Function to sign in with Facebook
   */
  signInWithApple?(...args: unknown[]): unknown;
  /**
   * is loading state
   */
  isLoading?: boolean;
}

const ViewComponent = ({
  isLoading,
  socialDisabled,
  signInWithApple,
}: ViewComponentProps) => (
  <SkeletonLoader
    isLoading={isLoading}
    width="100%"
    height={44}
    wrapperClassName="w-full md:ml-4"
    afterLoading={
      <button
        className="relative flex flex-row w-full h-12 p-3 social-shadow bg-neutral-900 rounded-3xl"
        type="button"
        id="apple_sign_in"
        disabled={socialDisabled}
        onClick={signInWithApple}
      >
        <img
          src={AppleLogo}
          alt="f-logo"
          className="absolute w-5 h-6 left-3 top-1/2 transform -translate-y-1/2"
        />
        <p className="w-full my-auto text-center text-14-22-em text-neutral-000 whitespace-nowrap">
          Sign in with Apple
        </p>
      </button>
    }
  />
);

ViewComponent.defaultProps = {
  isLoading: false,
  socialDisabled: undefined,
  signInWithApple: undefined,
};

ViewComponent.displayName = 'Login-Apple-view';

export default ViewComponent;
